import type { ReactNode } from "react";
import { TooltipProvider } from "./Button";
import { CsrfContext } from "./data/command";
import { NavigateProvider } from "./Link";
import { ToastProvider } from "./Toast";

export function UiProvider({
  navigate,
  csrf,
  children,
}: {
  navigate: (href: string) => void;
  csrf: () => string | null;
  children: ReactNode;
}) {
  return (
    <NavigateProvider navigate={navigate}>
      <CsrfContext value={csrf}>
        <TooltipProvider>
          <ToastProvider>{children}</ToastProvider>
        </TooltipProvider>
      </CsrfContext>
    </NavigateProvider>
  );
}
